import { QUESTIONNAIRE_EVALUATION as MODULE_PREFIX } from '../constants';
export const QUESTIONNAIRE_EVALUATION_SAVE_REQUEST = `${MODULE_PREFIX}_SAVE_REQUEST`;
export const QUESTIONNAIRE_EVALUATION_SAVE_REQUEST_SUCCESS = `${MODULE_PREFIX}_SAVE_REQUEST_SUCCESS`;
/* Created Request Action for save questionnaire evaluation data */
export const questionnaireEvaluationSaveRequestAction = (requestData, hasEvaluated) => ({
    type: QUESTIONNAIRE_EVALUATION_SAVE_REQUEST,
    payload: {
        requestData: requestData,
        hasEvaluated: hasEvaluated ? hasEvaluated : false
    }
});
/* Created Success Action for save questionnaire evaluation Data */
export const questionnaireEvaluationSaveRequestSuccessAction = () => ({
    type: QUESTIONNAIRE_EVALUATION_SAVE_REQUEST_SUCCESS,
    payload: null
});
//# sourceMappingURL=questionnaireEvaluationSaveActions.js.map